import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const state = {
	addressResults: [],
	searchValue: "",
	didSearch: false,
	isLoading: false,
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
